import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

import { newsRequest, deleteNewsRequestCompleted } from '../actions';

const { takeEvery, put, take } = sagaEffects;

function* handler({ meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    const collection = meta.delayed ? config.collections.newsDelayed : config.collections.news;

    try {
        const batch = firestore.batch();

        for (const lang of config.app.languages) {
            const ref = yield firestore.doc(`languages/${lang}/${collection}/${meta.id}`);
            batch.delete(ref);
        }

        yield batch.commit();

        message.success(intl.formatMessage({ id: 'success.news.delete' }));
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.news.delete' }));
    } finally {
        yield put(newsRequest({ silent: true }));
        yield take(types.NEWS_REQUEST_COMPLETED);
        yield put(deleteNewsRequestCompleted(meta.id));
    }
}
export default function* () {
    yield takeEvery(types.DELETE_NEWS_REQUEST, handler);
}
